export function getHeadingHeight(params: IHeadingHeightContainer) {
  const { 'data-offsettop': offsettop } = params;
  /* Height does not include padding */
  return offsettop + 24;
}
export interface IHeadingHeightContainer {
  'data-offsettop': number;
}
